module.exports = __webpack_public_path__ + "media/fyt_m10.93024af2.mp4";